script_on_load('google-map', function(){
	if($('#dealers-map').length && mapData.dealers != null){
		const geocoder = new google.maps.Geocoder();
		var map;
		var MY_MAPTYPE_ID = 'custom_style';

		function initialize() {
			var featureOpts = [];
					
			var mapOptions = {
				zoom: 10,
				scrollwheel : false,
				zoomControl: true,
				disableDefaultUI: true,
				center: new google.maps.LatLng(45.509062, -73.553363),
				labelContent: mapData.siteName,
				mapTypeControlOptions: {
					mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
				},
				mapTypeId: MY_MAPTYPE_ID
			};// mappOptions
					
			map = new google.maps.Map(document.getElementById('dealers-map'), mapOptions);
			
			var styledMapOptions = {
				name: 'Custom Style'
			};//StyledMapOptions
					
			var customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);
			
			map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

			var markerNumber = 1;
			var bounds = new google.maps.LatLngBounds();
			map.markers = [];

			$.each(mapData.dealers, function(index, val){
				let markerOpts = {
					position: new google.maps.LatLng(val.map.lat, val.map.lng),
					map: map,
					title: val.name,
					dealerID: index,
					icon: {
						url: mapData.childURI+"/images/marker_map.svg",
						anchor: new google.maps.Point(12.57, 38),
						labelOrigin: new google.maps.Point(12, 16),
					}
				};

				if(mapData.isDealersPage){
					markerOpts.label = {
						color: "#fff",
						fontFamily: 'Prompt',
						fontSize: "19px",
						fontWeight: "600",
						text: ''+markerNumber
					}
				}
				var markerMap = new google.maps.Marker(markerOpts);

				$('#dealer-list-map li[data-dealerID="'+index+'"] .marker-label span').text(markerNumber);
				$('#dealer-list-map').append($('#dealer-list-map li[data-dealerID="'+index+'"]'));
				
				map.markers.push(markerMap);
				bounds.extend(markerMap.position);
				
				markerMap.addListener('click', function(){
					if(mapData.isDealersPage){
						if(($(window).scrollTop() + $('#masthead').height()) > $('#search-dealers').offset().top){
							$('html, body').animate({
								scrollTop: $('#search-dealers').offset().top - $('#masthead').height()
							});
						}

						scroll_to_closest(index);
						
					}else{
						window.location = mapData.dealersPageURI+"/?param="+markerMap.title;
					}
				});

				markerNumber++;
			});

			google.maps.event.addDomListenerOnce(map, 'tilesloaded', function(){
				if(mapData.isDealersPage && mapData.searchParam != ''){
					if(mapData.searchParam == 'current-position'){
						find_position_by_geolocalisation();

					}else{
						postalLatLng(mapData.searchParam, function(latlng){
							find_closest(latlng.lat, latlng.lng);
						});
					}

				}else{
					map.fitBounds(bounds);
				}
			});

			function find_closest(lat, lng){
				var dealersPosition = [];
				var postalLatLng = new google.maps.LatLng({lat: lat, lng: lng});
				
				$.each(map.markers, function(index, marker){
					dealersPosition.push(marker.position);
				});
				
				// Google distance matrix limite la quantité d'origins et de destinations à 25 chaque.
				var totalRequest = Math.ceil(dealersPosition.length / 25);
				var requestsCount = 0;
				var failedRequestsCount = 0;
				var service = new google.maps.DistanceMatrixService();
				var dist = [];

				for(var i = 0; i < totalRequest; i++){
					let dealersRequest = dealersPosition.splice(0, 25); // On get les 25 premiers

					// On wrap le tous dans une function avec un callback pour garder la valeur de i dans le callback.
					(function(requestNum){
						service.getDistanceMatrix({
							origins: [postalLatLng],
							destinations: dealersRequest,
							travelMode: 'DRIVING',
							unitSystem: google.maps.UnitSystem.METRIC,
							avoidHighways: false,
							avoidTolls: false,
						}, getResults);
		
						function getResults(response, status){
							var realMarkerIndex = requestNum * 25; // Pour retrouver le bon index du marker, on utilise le numéro de la requête, car la première requête commence toujours à 0 (0-24) 0*25 = 0 la deuxième à 25 (25-49) 1*25 = 25

							if(status == 'OK'){
								var origins = response.originAddresses;
								//var destinations = response.destinationAddresses;
							
								for(var i = 0; i < origins.length; i++){
									var results = response.rows[i].elements;
		
									for(var j = 0; j < results.length; j++){
										var element = results[j];
										var distance = element.distance.value;
										// var duration = element.duration.text; Temps pour se rendre.
										
										dist.push({
											index:realMarkerIndex,
											dist: distance,
											position: map.markers[realMarkerIndex].position,
											dealerID: map.markers[realMarkerIndex].dealerID,
										});
										
										realMarkerIndex++;
									}
								}
		
							}else{
								failedRequestsCount++;
							}

							requestsCount++;

							if(totalRequest == requestsCount){
								updateMap(failedRequestsCount);
							}
						}
					})(i);
				}

				function updateMap(failedCount){
					if(failedCount == totalRequest){
						// En cas d'échec, on zoom sur l'adresse entrée.
						var bounds = new google.maps.LatLngBounds();
						bounds.extend(postalLatLng);
						map.fitBounds(bounds);

					}else{
						dist.sort(compare);
		
						var markerNumber = 1;
						$.each(dist, function(pos, elem){
							map.markers[elem.index].setLabel({
								color: "#fff",
								fontFamily: 'Prompt',
								fontSize: "19px",
								fontWeight: "600",
								text: ''+markerNumber
							});
		
							$('#dealer-list-map li[data-dealerID="'+elem.dealerID+'"] .dist').text((elem.dist/1000).toFixed(1) + " km");
							$('#dealer-list-map li[data-dealerID="'+elem.dealerID+'"] .marker-label span').text(markerNumber);
							$('#dealer-list-map').append($('#dealer-list-map li[data-dealerID="'+elem.dealerID+'"]'));
		
							markerNumber++;
						});
		
						var bounds = new google.maps.LatLngBounds();
						if(dist.length >= 1){
							bounds.extend(dist[0].position);
						}

						if(dist.length >= 2){
							bounds.extend(dist[1].position);
						}

						if(dist.length >= 3){
							bounds.extend(dist[2].position);
						}

						bounds.extend(postalLatLng);
						map.fitBounds(bounds);
		
						scroll_to_closest(dist[0].dealerID);
					}
				}
			}

			function scroll_to_closest(dealerID){
				var selectedLi = $('#dealer-list-map li[data-dealerID="'+dealerID+'"]');

				$('#dealer-list-map').animate({scrollTop: selectedLi.offset().top - ($('#dealer-list-map').offset().top - $('#dealer-list-map').scrollTop())});
			}

			// retourne la lat lng d'un code postal
			postalLatLng = function(codePostal, callback){
				geocoder.geocode( { address: codePostal, region: 'qc'}, function(results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						var latitude = results[0].geometry.location.lat();
						var longitude = results[0].geometry.location.lng();
						
						callback({lat: latitude, lng: longitude});
					}
					return false;
				});
			};

			// ordonne un array par distance
			function compare(a,b) {
				if (a.dist < b.dist)
					return -1;
				if (a.dist > b.dist)
					return 1;
				return 0;
			}

			function find_position_by_geolocalisation(){
				if("geolocation" in navigator){
					navigator.geolocation.getCurrentPosition(function(position) {
						find_closest(position.coords.latitude, position.coords.longitude);
					});
				}
			}

			if(mapData.isDealersPage){
				$('#search-dealers form').submit(function(e){
					e.preventDefault();

					var search_param = $(this).find('input[name="param"]').val();
	
					var url = new URL(window.location);
					
					if(search_param != ''){
						url.searchParams.set('param', search_param);

						postalLatLng(search_param, function(latlng){
							find_closest(latlng.lat, latlng.lng);
						});

					}else{
						url.searchParams.delete('param');
					}

					history.pushState(null, '', url.href); // Change le URL.
				});
			}

			if("geolocation" in navigator){
				if(mapData.isDealersPage){
					$('.find-with-current-pos').on('click', function(e){
						e.preventDefault();
						find_position_by_geolocalisation();
					});
				}

			}else{
				$('.find-with-current-pos').remove();
			}

		}// init

		initialize();

		$('#dealer-list-map .more').on('click', function(e){
			if($(this).hasClass('opened')){
				$(this).removeClass('opened').next('.more-details').hide(300);

			}else{
				$(this).addClass('opened').next('.more-details').show(300);
			}
		});
	}
});